export const baseUrl = process.env.REACT_APP_API_ROOT;

const requests = {
    NOTICE_LIST: '/api/notice',
    PROJECT: '/api/contact/project',
    JOIN: '/api/contact/join'
};

export default requests;
